import { useEffect, useState } from 'react'
import { api } from '../../shared/api/http'

export function useCameraProvisioning(companyId: string, clientId: string) {
  const [value, setValue] = useState({ scope: '', canConfigure: false, canCreateRtmp: false, loading: true })
  const scope = `${companyId}/${clientId}`
  useEffect(() => {
    let active = true
    setValue({ scope, canConfigure: false, canCreateRtmp: false, loading: true })
    if (!companyId || !clientId) { setValue({ scope, canConfigure: false, canCreateRtmp: false, loading: false }); return }
    api<{ canConfigure: boolean; canCreateRtmp: boolean }>(`/companies/${companyId}/clients/${clientId}/camera-provisioning`)
      .then(result => { if (active) setValue({ scope, ...result, loading: false }) })
      .catch(() => { if (active) setValue({ scope, canConfigure: false, canCreateRtmp: false, loading: false }) })
    return () => { active = false }
  }, [companyId, clientId, scope])
  return value.scope === scope ? value : { canConfigure: false, canCreateRtmp: false, loading: true }
}
